import jss from 'jss';
import preset from 'jss-preset-default';


/**
 * By default JSS creates unique class names based on the name you pass in. If
 * you pass in “hello” as a class name, JSS will return “hello-0-1”. Because we
 * key off of the class names for creating the styles, we need a name we can
 * format ourselves. `createGenerateId` allows us to override JSS’s internal
 * mechanism and format the classes as we see fit.
 *
 * @method createGenerateId
 * @return {String}         Formatted class name
 */
const createGenerateId = () => (rule) => rule.key.toString().replace(/\./, '');


export default jss
	.setup({ createGenerateId }, preset());
